import { AddDepartmentRequestSchema, AddDepartmentResponseSchema } from './add-department.schema';
/**
 * Add Department Endpoint Contract
 * Creates a new department in the organization
 */ export const addDepartmentContract = {
    method: 'POST',
    path: '/api/v2/department',
    description: 'Create a new department in the organization',
    requestSchema: AddDepartmentRequestSchema,
    responseSchema: AddDepartmentResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=add-department.contract.js.map